<template>
  <h-e-rectangle
    v-if="date"
    :color-full="true"
    :bg-color="formatBgColor"
    icon="mdi mdi-clock-outline"
    :title="formatTitle"
  ></h-e-rectangle>
</template>

<script>
import moment from 'moment'

export default {
  name: 'deadline',

  props: {
    date: {
      type: [String, Date],
      required: true,
    },
  },

  computed: {
    formatBgColor() {
      const date = new Date(this.date)
      if (date < new Date()) {
        return 'danger'
      }
      if (date >= new Date() - 2 && date <= new Date()) {
        return 'warning'
      }
      return 'primary'
    },

    formatTitle() {
      return moment(this.date).format('DD/MM/yyyy')
    },
  },
}
</script>

<style scoped>
</style>